module.exports = __webpack_public_path__ + "static/media/user-bio.46916bfc.svg";